module.exports = __webpack_public_path__ + "img/stars.4f445833.svg";